export enum LCOnboardingTrackEvent {
  LC_ONBOARDING_START = 'LC_onboarding_start',
  LC_ONBOARDING_STEP1_SAVE = 'LC_onboarding_step1_save',
  LC_ONBOARDING_STEP2_CONTINUE = 'LC_onboarding_step2_continue',
  LC_ONBOARDING_STEP3_FINISH = 'LC_onboarding_step3_finish',
  LC_CHANGE_TYPE_OF_TEACHER_CLICK = 'LC_change_type_of_teacher_click',
  LC_CHANGE_TYPE_OF_TEACHER_NATIVE = 'LC_change_type_of_teacher_native',
  LC_CHANGE_TYPE_OF_TEACHER_BILINGUAL = 'LC_change_type_of_teacher_bilingual',
  LC_CHANGE_TYPE_OF_TEACHER_X = 'LC_change_type_of_teacher_x',
}

export enum LCOboardingEventType {
  LC_ONBOARDING_FINISHED = 'LC_onboarding_finished',
  LC_ONBOARDING_TRACKING_EVENT = 'LC_onboarding_tracking_event',
}
